// extracted by mini-css-extract-plugin
export default {"root":"RepliesContainer_root__0Khph","rootOneReply":"RepliesContainer_rootOneReply__ENalg"};